import { Pipe, PipeTransform } from '@angular/core';
import * as Moment from 'moment';
import { CONFIG } from '../constants/config.constants';

@Pipe({
  name: 'serverDatetimeToDisplayDatetimePipe'
})
export class ServerDatetimeToDisplayDatetimePipe implements PipeTransform {
	transform(value: any): string {
		if (value) {
			// If input is object date
			if (value.year) {
				return Moment({
					year: value.year,
					month: value.month - 1,
					day: value.day,
				}).format(CONFIG.dateFormat).valueOf();
			} else {
				return Moment(value).format(CONFIG.datetimeFormat).valueOf();
			}
		}

		return '';
	}
}
